// Static demo site lives in public/ as plain HTML/CSS/JS.
// Only mount React if a host page provides a #root element (none do).
const container = document.getElementById("root");
if (container) {
  Promise.all([
    import("react"),
    import("react-dom/client"),
    import("@tanstack/react-query"),
    import("@/index.css"),
    import("@/App"),
  ]).then(([React, ReactDOM, { QueryClient, QueryClientProvider }, , App]) => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: { staleTime: 60_000, refetchOnWindowFocus: false },
      },
    });
    ReactDOM.createRoot(container).render(
      React.default.createElement(
        QueryClientProvider,
        { client: queryClient },
        React.default.createElement(App.default)
      )
    );
  });
}
